import { atom } from 'recoil';
import { ActionState } from "common/types";

export const fetchError = atom<ActionState>({
  key: 'FETCH_ERROR',
  default: ActionState.NotSet
});